<template>
  <b-modal
      ref="desc-kanban-be-modal"
      hide-footer
      title="Edition de votre carte Kanban BE"
  >
    <div class="d-block text-center">
      <b-container fluid>
        <br>
        <b-row>
          <b-col sm="3">
              <label>Descriptif :</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea v-model="form.descriptif" rows="2" max-rows="2" maxlength="150"></b-form-textarea>
            </b-col>
        </b-row>
        <br>
        <hr>
        <b-row>
          <b-col sm="2" style="margin:auto">
            <div v-show="loading" class="text-center">
              <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
          </b-col>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-info"
              block
              :disabled="!form.descriptif"
              @click="savedModification"
            >
              Enregistrer
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'UpdateDescKbBeModal',
  data() {
    const now = new Date()
    const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
    return {
      kanban: null,
      loading: false,
      cardNumber: '',
      form:{
        descriptif: '',
      }
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    hideModal () {
      this.$refs['desc-kanban-be-modal'].hide()
    },
    showModal (item) {
      this.cardNumber = item.card_number
      this.form.descriptif = item.descriptif
      this.$refs['desc-kanban-be-modal'].show()
    },
    savedModification () {
      this.loading = true
      server.editKanbanBe(this.cardNumber, this.form).then(res => {
        this.$toasted.success('Modification enregistré!')
        this.$emit('saved')
        this.hideModal()
        this.cleanForm()
        this.loading = false
      }).catch((error) => {
        this.$toasted.error(`Mince ! Une erreur <br> ${error.response.data.message}`)
      })
    },
    cleanForm () {
      this.form.descriptif= ''
    }
  },
  mounted: function() {
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/modal/UpdateDescKbBeModal.vue